import { supabase } from '../lib/supabase'

export async function hydrateCandidates(candidateRows) {
  if (!candidateRows.length) return []
  const ids = candidateRows.map(c => c.id)

  async function readRows(table, fields) {
    const rows = []
    for (let i = 0; i < ids.length; i += 100) {
      for (let page = 0; ; page++) {
        if (page >= 100) throw new Error('Candidate evidence exceeds the retrieval limit')
        const { data, error } = await supabase.from(table).select(fields)
          .in('candidate_id', ids.slice(i, i + 100)).order('id').range(page * 500, (page + 1) * 500 - 1)
        if (error) throw error
        rows.push(...(data || []))
        if (!data || data.length < 500) break
      }
    }
    return rows
  }
  const positionRows = await readRows('candidate_positions', 'candidate_id, dimension, score')
  const evidenceRows = await readRows('candidate_evidence', 'candidate_id, topic, score_justification, source_url, confidence_score')

  const posMap = {}
  for (const row of positionRows) {
    if (!posMap[row.candidate_id]) posMap[row.candidate_id] = {}
    posMap[row.candidate_id][row.dimension] = row.score
  }

  const evMap = {}
  for (const row of evidenceRows) {
    if (!evMap[row.candidate_id]) evMap[row.candidate_id] = []
    evMap[row.candidate_id].push({
      topic: row.topic,
      score_justification: row.score_justification,
      source_url: row.source_url,
      confidence_score: row.confidence_score,
    })
  }

  const merged = candidateRows.map(c => ({
    ...c,
    position_vector: posMap[c.id] || {},
    evidence_ledger: evMap[c.id] || [],
  }))

  return merged
}
